// --------------------------------------------------------------------------
// #4 – LOCATION
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context,
        selectedLocation = context.find('select').val();

    function init() {
        /**
        * Populate location
        */
        context.find('.location-block__name').text(selectedLocation);

        //Get height of box
        var expandedHeight = context.find('.location-block__content button').outerHeight();

        /**
        * Show location select box
        */
        context.on('click', '.location-block__button', function (e) {
            e.preventDefault();
            if (!context.hasClass('isVisible')) {
                $(this).siblings('.location-block__content').animate({ 'height': expandedHeight });
            }
        });

        //Add accessible display
        context.on({
            focus: function focus() {
                $(this).siblings('.location-block__content').animate({ 'height': expandedHeight });
            }
        }, '.location-block__button');
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/change-location.js
// module id = 182
// module chunks = 0